import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, switchMap, take, tap } from 'rxjs/operators';
import { AccountInformationState } from '../reducers/account-information.reducer';
import { LoadAccountInformation } from '../actions';
import {
  getAccountInformation,
  getAccountInformationLoaded
} from '../selectors';
import { Account } from '../../model/account';
import { Injectable } from '@angular/core';

@Injectable()
export class AccountFacade {
  constructor(private store: Store<AccountInformationState>) {}

  public getAccountInformationFromStore(): Observable<Account> {
    return this.checkAccountInformationStore().pipe(
      switchMap(() => {
        return this.store.pipe(select(getAccountInformation));
      })
    );
  }

  private checkAccountInformationStore(): Observable<boolean> {
    return this.store.pipe(
      select(getAccountInformationLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(new LoadAccountInformation());
        }
      }),
      filter((loaded: boolean) => loaded),
      take(1)
    );
  }
}
